<div class="agpr-formField agpr-textField">
    @if (field.label) {
        <label
            class="agpr-formField-label"
            [id]="id + '-label'"
        >
            {{ field.label | localize }}
        </label>
    }
    <agpr-date-query-popup
        #dateQueryPopup
        [id]="id"
        [(ngModel)]="dateRange"
        [options]="dateFilterOptions"
        [searchRange]="(showAllOption || (this.block && gaChartType[this.block.type.key])) ? null : searchRange"
        [dateTypeOptions]="dateTypeOptions"
        [hideDateTypeSelection]="hideDateTypeSelection"
        (ngModelChange)="dateRangeChanged()"
        [ariaLabelledBy]="field.label ? id + '-label' : null"
    >
    </agpr-date-query-popup>
    @if (field.description) {
        <div
            class="agpr-formField-description"
        >
            {{ field.description | localize }}
        </div>
    }
</div>
